import React from 'react';
import styled from 'styled-components';
import { PropTypes } from 'prop-types';
import Constants from '../../submodules/logictry_config/constants';
import '../../services/Errors';
import LogictryComponent from '../../submodules/logictry_config/LogictryComponent';

const Wrapper = styled.div`
  color: ${Constants.DarkTextColor};
`;

export default class Application extends LogictryComponent {
  static propTypes = {
    children: PropTypes.any,
  }
  render() {
    return (
      <Wrapper>
        {this.props.children}
      </Wrapper>
    );
  }
}
